<template>
  <ankh-list :showBtnGroup="false">
    <template #search-form>
      <el-form-item :label="$t('会员编号')">
        <el-input :placeholder="$t('会员编号')" v-model="searchForm.vipNum" clearable/>
      </el-form-item>
      <el-form-item :label="$t('会员昵称')">
        <el-input :placeholder="$t('会员昵称')" v-model="searchForm.username" clearable/>
      </el-form-item>
      <el-form-item :label="$t('账号注册时间')">
        <date-time-range-picker
            value-format="timestamp"
            :start-time.sync="searchForm.startRegisterTime"
            :end-time.sync="searchForm.endRegisterTime"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
      <br>


      <el-form-item :label="$t('会员等级')">
        <el-select v-model="searchForm.vipLevel" clearable :placeholder="$t('会员等级')">
          <el-option v-for="item in vipLevel" :key="item.code" :value="item.code" :label="item.name"/>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('会员积分')">
        <div style="display: flex;column-gap: 10px">
          <el-input :placeholder="$t('最低会员积分')" clearable v-model="searchForm.lowVipIntegral"/>
          <span>-</span>
          <el-input :placeholder="$t('最高会员积分')" clearable v-model="searchForm.highVipIntegral"/>
        </div>
      </el-form-item>
      <br>

      <el-form-item :label="$t('使用者等级')">
        <el-select v-model="searchForm.useLevel" clearable :placeholder="$t('使用者等级')">
          <el-option v-for="item in userLevelList" :key="item.code" :value="item.code" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('使用者积分')">
        <div style="display: flex;column-gap: 10px">
          <el-input :placeholder="$t('最低使用者积分')" clearable v-model="searchForm.lowUseIntegral"/>
          <span>-</span>
          <el-input :placeholder="$t('最高使用者积分')" clearable v-model="searchForm.highUseIntegral"/>
        </div>
      </el-form-item>
      <br>

      <el-form-item :label="$t('发布者等级')">
        <el-select v-model="searchForm.releaseLevel" clearable :placeholder="$t('发布者等级')">
          <el-option v-for="item in releaseLevel" :key="item.code" :value="item.code" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('发布者积分')">
        <div style="display: flex;column-gap: 10px">
          <el-input :placeholder="$t('最低发布者积分')" clearable v-model="searchForm.lowReleaseIntegral"/>
          <span>-</span>
          <el-input :placeholder="$t('最高发布者积分')" clearable v-model="searchForm.highReleaseIntegral"/>
        </div>
      </el-form-item>
      <br>
      <el-button type="primary" style="margin-bottom: 10px" @click="handleExport">{{$t('导出')}}</el-button>

    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">
        <el-table-column type="selection" width="50"/>
        <el-table-column
            type="index"
            width="50" :label="$t('序号')">
        </el-table-column>
        <el-table-column :label="$t('会员编号')">
          <template v-slot="{row}">
            {{ row.vipNum || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="username" :label="$t('会员昵称')"/>
        <el-table-column prop="portrait" :label="$t('会员头像')">
          <template v-slot="{row}">
            <preview-img fit="contain" :img-url="row.portrait" :size="60"/>
          </template>
        </el-table-column>
        <el-table-column prop="registerTime" :label="$t('账号注册时间')">
          <template v-slot="{row}">
            {{ row.registerTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="vipLevel" :label="$t('会员等级')" sortable/>
        <el-table-column :label="$t('会员积分')" prop="vipIntegral" sortable/>
        <el-table-column :label="$t('使用者等级')" prop="useLevel" sortable/>
        <el-table-column :label="$t('使用者积分')" prop="useIntegral" sortable/>
        <el-table-column :label="$t('发布者等级')" prop="releaseLevel" sortable/>
        <el-table-column :label="$t('发布者积分')" prop="releaseIntegral" sortable/>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "IntegralList",
  components: {AnkhList, PreviewImg, DateTimeRangePicker, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],

      userLevelList: [],
      releaseLevel: [],
      vipLevel: []
    }
  },
  methods: {
    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.userVipRecord.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    // 请求使用者等级
    async getUserLevel() {
      try {
        let res = await request(this.$api.userVipLevel.list);
        this.userLevelList = res.userVipLevels;
      } catch (e) {
        console.log(e);
      }
    },
    // 请求发布者等级
    async getReleaseLevel() {
      try {
        let res = await request(this.$api.releaseVipLevel.list, {onPage: false});
        this.releaseLevel = res.releaseVipLevels;
      } catch (e) {
        console.log(e);
      }
    },

    // 请求会员等级
    async getVipLevel() {
      try {
        let res = await request(this.$api.vipLevel.list, {onPage: false});
        this.vipLevel = res.vipLevels;
      } catch (e) {
        console.log(e);
      }
    },
    handleExport() {
      const codes = this.selection.map(item => item.code);
      console.log(codes)
      console.log(this.$api.exportData.userVipRecord)
      const url = this.$api.exportData.userVipRecord += `?codes=${codes.join(",")}`;
      const a = document.createElement("a");
      console.log("url", url)
      a.href = url;
      a.click();

    }
  },
  created() {
    this.getUserLevel();
    this.getReleaseLevel();
    this.getVipLevel();
  }
}
</script>

<style scoped>

.row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
}

el-form-item {
  margin-right: 10px;

}

el-button {
  margin-left: 20px;
}
</style>
